// tslint:disable-next-line:no-import-side-effect
import "../commonBoot";
// tslint:disable-next-line:no-import-side-effect
import "../filters";

import Vue from "vue";
import { apolloProvider } from "../apollo";
import App from "../App.vue";
import navigationGuard from "../navigationGuard";

import store from "../store";
import router from "./router";

navigationGuard(router);

import { i18n, initI18nRouter } from "../i18n";
initI18nRouter(router);

import { sync } from "vuex-router-sync";
sync(store, router);

(window as any).vue = new Vue({
  render: (h) => h(App),
  router,
  store,
  apolloProvider,
  i18n,
}).$mount("#app");
